import { FC, useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useRecoilValue } from "recoil";

import {
  MessagesDisplayContainer,
  PhoneTemplate,
  TextboxTemplate,
} from "@ryde/controls";
import {
  apiDataFetchingLandingAtom,
  landingMessagesAtom,
  LoginStepFormFieldsEnum,
} from "@ryde/utils-landings";

import { ContinueButton } from "../../widgets";
import { useStepLogin } from "./use-step-login";

export const StepLogin: FC = () => {
  const { methods, handleLogin, isContinueCanBeApply } = useStepLogin();
  const [searchParams, setSearchParams] = useSearchParams();
  const landingMessages = useRecoilValue(landingMessagesAtom);
  const isApiLoading = useRecoilValue(apiDataFetchingLandingAtom);
  const { t } = useTranslation();

  useEffect(() => {
    if (searchParams) {
      setSearchParams("");
    }
  }, [searchParams, setSearchParams]);

  return (
    <FormProvider {...methods}>
      <form noValidate onSubmit={e => e.preventDefault()}>
        <div className="landing-top-illustration" aria-hidden="true"></div>
        <h1 className="landing-title">
          {t("landing.login.title")}
          <br />
          {t("landing.login.subTitle")}
        </h1>

        <div className="landing-form-field">
          <label htmlFor={LoginStepFormFieldsEnum.WorkerId}>
            {t("landing.formLabel.workerId")}*
          </label>
          <TextboxTemplate
            uniqueAttrId={LoginStepFormFieldsEnum.WorkerId}
            name={LoginStepFormFieldsEnum.WorkerId}
          />
        </div>

        <div className="landing-form-field">
          <label htmlFor={LoginStepFormFieldsEnum.Phone}>
            {t("landing.formLabel.phone")}*
          </label>
          <PhoneTemplate
            name={LoginStepFormFieldsEnum.Phone}
            sx={{ size: "small" }}
            formAttributes={{ disablePhoneCallable: true }}
            uniqueAttrId={LoginStepFormFieldsEnum.Phone}
          />
        </div>

        <MessagesDisplayContainer
          serverMessages={landingMessages?.messages}
          type={landingMessages?.type}
        />

        <ContinueButton
          loading={isApiLoading}
          disabled={!isContinueCanBeApply}
          onClick={handleLogin}
        />
      </form>
    </FormProvider>
  );
};
